
import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';

const Finance = () => {
  // Redirect to pending approvals as the default view
  return <Navigate to="/finance/approvals/pending" replace />;
};

export default Finance;
